var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupplyX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006cff",
    d: "M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.8,7.7H10.7V9.1h-.2a5.653,5.653,0,0,0-3,.8c-1.2.8-2.5,2-2.6,5.4H8.3c0-3,1.8-2.9,2.3-2.9h0v.7h5.1v-.7h1.5V9.1H15.7V7.7Zm.9,2v2H15.1v.7H11.4v-.7h-.9c-1.7,0-2.6,1-2.8,2.9h-2a4.982,4.982,0,0,1,2.2-4.2,4.545,4.545,0,0,1,2.6-.7h.9V8.3h3.7V9.7h1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    width: 1.9,
    height: 6.8,
    transform: "translate(17.9 7.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.8,5h1.8V6.9h1.2V5h1.8a.472.472,0,0,0,.5-.5V4.2a.472.472,0,0,0-.5-.5H13.8V3.5a.6.6,0,0,0-1.2,0v.3H10.8a.472.472,0,0,0-.5.5v.2A.536.536,0,0,0,10.8,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.3,18.5a1.324,1.324,0,0,0,1.3,1.3A1.415,1.415,0,0,0,8,18.5a9.671,9.671,0,0,0-1.3-2.7A9.408,9.408,0,0,0,5.3,18.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupplyX24);
export default __webpack_public_path__ + "static/media/water-supply-x24.9122ee2a2206b4d17c9f2f4b6d8b717a.svg";
export { ForwardRef as ReactComponent };